import {utils_tool} from "@/tool";

const {Session} = utils_tool

const getDetailRecord = (history) => {
  let pathname = history.location.pathname;

  let detailInfo = ''
  const sessionName = pathname.split('/').filter(item => !!item).join('-') + '-Record'
  if (history?.location?.record) {
    detailInfo = history.location.record || {}
    Session.add(sessionName, detailInfo)
  } else {
    detailInfo = Session.get(sessionName) || {}
  }
  return detailInfo
}

export {getDetailRecord}
